import service from './service'

import config from './config'

const { defaultHeaders } = config

const { VITE_API_BASE_PATH } = import.meta.env

const request = (option: AxiosConfig) => {
  const { url, method, params, data, headersType, responseType } = option
  return service.request({
    url: VITE_API_BASE_PATH + url,
    method,
    params,
    data,
    responseType: responseType,
    withCredentials: true,
    headers: {
      'Content-Type': headersType || defaultHeaders
    }
  })
}

export default {
  get: <T = any>(option: AxiosConfig) => {
    return request({ method: 'get', ...option }) as Promise<IResponse<T>>
  },
  post: <T = any>(option: AxiosConfig) => {
    return request({ method: 'post', ...option }) as Promise<IResponse<T>>
  },
  delete: <T = any>(option: AxiosConfig) => {
    return request({ method: 'delete', ...option }) as Promise<IResponse<T>>
  },
  put: <T = any>(option: AxiosConfig) => {
    return request({ method: 'put', ...option }) as Promise<IResponse<T>>
  },
  cancelRequest: (url: string | string[]) => {
    return service.cancelRequest(url)
  },
  cancelAllRequest: () => {
    return service.cancelAllRequest()
  }
}
